define('models/validator/cardnumberlinked',["backbone",
        "models/validator/cardnumbervisa",
        "models/validator/cardnumbermastercard"
], function (Backbone, VisaCardValidator, MasterCardValidator) {
    "use strict";

    var LinkedCardValidator = VisaCardValidator.extend(new MasterCardValidator);
    return LinkedCardValidator.extend({

        defaults: {
            cardType: null,
            validationType: enums.validationType.cardNumberLinked
        },

        validate: function(val) {
            val = val.replace(/[ -]/g, ''), // Strip spaces and dashes
            this.set('value', val);

            var code = this.validateHasValue(val),
                cardType = null;
            
            if ( this.isValid(code) ) {
                code = this.validateCardNumberVisa(val);
                
                // If it's a valid visa number, set the model's cardType attr
                if ( this.isValid(code) ) {
                    cardType = enums.networkSources.Visa;
                } else { // If not valid, continue to check if it's a mastercard
                    code = this.validateCardNumberMasterCard(val);
                    // If it's a valid mastercard number, set the model's cardType attr
                    if ( this.isValid(code) ) {
                        cardType = enums.networkSources.MasterCard;
                    }
                }
            }

            this.set('validationCode', code);
            this.set('cardType', cardType);
            return code;
        }
    });
});
